import { render, staticRenderFns } from "./defaultRisk.vue?vue&type=template&id=6c0de8e4&scoped=true&"
import script from "./defaultRisk.vue?vue&type=script&lang=js&"
export * from "./defaultRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0de8e4",
  null
  
)

export default component.exports